<script setup lang="ts">
defineProps<{
  name: string
  size?: 'sm' | 'md' | 'lg'
}>()
</script>

<template>
  <span
    class="material-symbols-outlined select-none leading-none"
    :class="{
      'text-[18px]': size === 'sm',
      'text-[24px]': size === 'md' || !size,
      'text-[32px]': size === 'lg',
    }"
  >{{ name }}</span>
</template>
